import { render, staticRenderFns } from "./PricePair.vue?vue&type=template&id=10e2dbe5&scoped=true&"
import script from "./PricePair.vue?vue&type=script&lang=js&"
export * from "./PricePair.vue?vue&type=script&lang=js&"
import style0 from "./PricePair.vue?vue&type=style&index=0&id=10e2dbe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2dbe5",
  null
  
)

export default component.exports